import {logErrorToSentry} from "../../utils/errors/logErrorToSentry";
import type {AppState} from "@stores/AppState";
import { IAuthService } from "../../platform/services/auth/AuthService";
import { IDataClientService } from "../../platform/services/data/DataClientService";

import {undoManager} from "../common/UndoManager";
import {HOTKEYS_SCOPE, setScope} from "../../utils/hotkeys";
import { unregisterBrowserPushSubscription } from "../notification/pushSubscriptions";
import { unsavedChangesManager } from "@stores/UnsavedChangesManager";


export const logout = async (appState: AppState, authService: IAuthService, dataClientService: IDataClientService) => {
    try {
        await unregisterBrowserPushSubscription(
            {
                authService,
                dataClientService,
            },
            {
                unsubscribeBrowser: true,
            }
        );
    } catch (error: unknown) {
        logErrorToSentry(error as any);
    }
    try {
        await authService.signOut();
    } catch (error: unknown) {
        logErrorToSentry(error as any);
    }
    unsavedChangesManager.declareNoUnsavedChanges();
    appState.resetState();
    undoManager.resetState();
    setScope(HOTKEYS_SCOPE.UNAUTHORIZED);
    try {
        await dataClientService.disconnectAllWsClients();
    } catch (error: unknown) {
        logErrorToSentry(error as any);
    }
}
